import React from 'react';
import { Redirect } from 'react-router-dom';
import basePath from 'utils/basePath';

const B2BRoutes = [
  <Redirect
    key={'lonely-planet'}
    path={`${basePath}/lonely-planet/`}
    to={`${basePath}/`}
  />
];

export default B2BRoutes;
